import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCadouhApiService } from '../../../shared/services/base-cadouh-api.service';
import { LimitOffsetPagination } from '../../../shared/models/limit-offset-pagination';
import { GenericPaginationResponseBody } from '../../../shared/models/Generic-pagination-response-body';
import { Driver } from '../models/driver';
import { CreateDriverPayload, UpdateDriverPayload } from '../models/driver-payload';
import { DriverAssignment } from '../models/driver-assignment';
import { DriverDelivery } from '../models/driver-delivery';

@Injectable({
  providedIn: 'root'
})
export class DriversManagementApiService extends BaseCadouhApiService {

  private readonly driversUrl = `${this.baseUrl}/giftshop/delivery_drivers`;

  getDrivers(pagination: LimitOffsetPagination, search: string = ''): Observable<GenericPaginationResponseBody<Driver>> {
    const params = new URLSearchParams({
      limit: String(pagination.limit),
      offset: String(pagination.offset),
    });
    if (search) params.set('search', search);
    return this.http.get<GenericPaginationResponseBody<Driver>>(
      `${this.driversUrl}/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken() }
    );
  }

  getDriverById(id: string | number): Observable<Driver> {
    return this.http.get<Driver>(`${this.driversUrl}/${id}/`, { headers: this.getRequestHeadersWithToken() });
  }

  createDriver(payload: CreateDriverPayload): Observable<Driver> {
    return this.http.post<Driver>(`${this.driversUrl}/`, payload, { headers: this.getRequestHeadersWithToken() });
  }

  updateDriver(id: string | number, payload: UpdateDriverPayload): Observable<Driver> {
    return this.http.put<Driver>(`${this.driversUrl}/${id}/`, payload, { headers: this.getRequestHeadersWithToken() });
  }

  setDriverActive(id: string | number, isActive: boolean): Observable<Driver> {
    return this.http.patch<Driver>(`${this.driversUrl}/${id}/`, { is_active: isActive }, { headers: this.getRequestHeadersWithToken() });
  }

  getDriverAssignmentHistory(id: string | number, pagination: LimitOffsetPagination): Observable<GenericPaginationResponseBody<DriverAssignment>> {
    const params = new URLSearchParams({ limit: String(pagination.limit), offset: String(pagination.offset) });
    return this.http.get<GenericPaginationResponseBody<DriverAssignment>>(
      `${this.driversUrl}/${id}/assignment_history/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken() }
    );
  }

  getDriverDeliveries(id: string | number, pagination: LimitOffsetPagination): Observable<GenericPaginationResponseBody<DriverDelivery>> {
    const params = new URLSearchParams({ limit: String(pagination.limit), offset: String(pagination.offset) });
    return this.http.get<GenericPaginationResponseBody<DriverDelivery>>(
      `${this.driversUrl}/${id}/deliveries/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken() }
    );
  }
}
